import React, { PureComponent } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import get from 'lodash/get';

class CustomSelect extends PureComponent {
  onChange = (value, option) => {
    const { data, onChange } = this.props;

    onChange(data, value, option);
  };

  renderSelect = () => {
    const {
      value,
      options,
      getOptionLabel,
      getOptionValue,
      onChange,
      label,
      errors,
      horizontal,
      data: {
        id,
      },
      ...rest
    } = this.props;

    return (
      <>
        <Select
          value={value}
          onChange={this.onChange}
          options={options}
          getOptionLabel={getOptionLabel}
          getOptionValue={getOptionValue}
          placeholder="Wybierz"
          noOptionsMessage={() => 'Brak opcji do wyboru'}
          {...rest}
        />
        {errors && get(errors, id) && <div className="errors">{get(errors, id)}</div>}
      </>
    );
  }

  render() {
    const {
      label,
      errors,
      horizontal,
      data: {
        id,
      },
    } = this.props;

    if (horizontal) {
      return (
        <div className="row form-group">
          <div className="col col-md-3">
            <label htmlFor={id} className="form-control-label">
              {label}
            </label>
          </div>
          <div className="col-12 col-md-9">
            {this.renderSelect()}
            {errors && get(errors, id) && <div className="errors">{get(errors, id)}</div>}
          </div>
        </div>
      );
    }

    return this.renderSelect();
  }
}

CustomSelect.defaultProps = {
  getOptionLabel: (option) => option.name,
  getOptionValue: (option) => option.id,
  data: {},
  onChange: () => { },
  label: '',
  horizontal: false,
};

CustomSelect.propTypes = {
  data: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.any,
  options: PropTypes.array,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  rest: PropTypes.objectOf(PropTypes.shape),
  label: PropTypes.string,
  horizontal: PropTypes.bool,
};

export default CustomSelect;
